/*
 * CAI: switch between connected products (the colour swatches and "Also available in") on the
 * product page without a full page load.
 *
 * WHY: each colour is a separate product, so tapping a swatch navigated to a new page (operator,
 * 25 Sep 2026: "not ajax loading like how we did in oath and uniseoul"). Ported from Uni Seoul's
 * uniseoul-style-swatch.js, with two changes: the next page is fetched as soon as a finger touches
 * the swatch, and every section the two pages share is swapped (buy box, reviews, recommendations),
 * not only the main one.
 *
 * Progressive enhancement: the swatches are real <a href> links. A modified click, another
 * template, or any failure falls back to normal navigation.
 */
(function () {
  if (window.__caiConnectedProductsBound) return;
  window.__caiConnectedProductsBound = true;

  var SWAP = 'a.alt-colors-swatch__item[href], a.alt-products__item[href]';
  var busy = false;
  var early = {};

  function prefetch(url) {
    if (!early[url]) {
      early[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
      early[url].catch(function () { delete early[url]; });
      setTimeout(function () { delete early[url]; }, 60000);
    }
    return early[url];
  }

  function sectionsIn(root) {
    return Array.prototype.slice.call(root.querySelectorAll('main .shopify-section[id^="shopify-section-"], #MainContent .shopify-section[id^="shopify-section-"]'));
  }

  function rerunScripts(node) {
    node.querySelectorAll('script').forEach(function (old) {
      if (old.type && old.type !== 'text/javascript' && old.type !== 'module') return;
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      s.textContent = old.textContent;
      old.replaceWith(s);
    });
  }

  function targetUrl(link) {
    var url;
    try { url = new URL(link.getAttribute('href'), location.origin); } catch (e) { return null; }
    if (url.origin !== location.origin || url.pathname.indexOf('/products/') === -1) return null;
    return url.toString();
  }

  async function swapTo(url, push) {
    if (busy) return false;
    busy = true;
    var main = document.querySelector('#MainContent') || document.querySelector('main');
    if (main) main.setAttribute('aria-busy', 'true');
    try {
      var html = await prefetch(url);
      delete early[url];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var current = sectionsIn(document);
      var incoming = {};
      sectionsIn(doc).forEach(function (s) { incoming[s.id] = s; });
      if (!current.length || current.some(function (s) { return !incoming[s.id]; })) throw new Error('template differs');
      current.forEach(function (s) {
        var fresh = document.importNode(incoming[s.id], true);
        s.replaceWith(fresh);
        rerunScripts(fresh);
        document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: s.id.replace('shopify-section-', '') } }));
      });
      if (doc.title) document.title = doc.title;
      if (push) history.pushState({ caiConnectedProduct: true }, '', url);
      document.dispatchEvent(new CustomEvent('shopify:product:select', { bubbles: true, detail: { url: url, source: 'cai-connected-products' } }));
      return true;
    } catch (e) {
      return false;
    } finally {
      if (main) main.removeAttribute('aria-busy');
      busy = false;
    }
  }

  // Once the next page's HTML is in, start its first gallery photos downloading too, so the
  // photos do not arrive a second after the swap.
  var warmedImages = {};
  function warmImages(url, html) {
    if (warmedImages[url]) return;
    warmedImages[url] = true;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var imgs = doc.querySelectorAll('.product-information media-gallery img');
    for (var i = 0; i < imgs.length && i < 3; i++) {
      var im = new Image();
      if (imgs[i].sizes) im.sizes = imgs[i].sizes;
      if (imgs[i].srcset) im.srcset = imgs[i].srcset;
      im.src = imgs[i].currentSrc || imgs[i].src;
    }
  }

  function warm(event) {
    var link = event.target.closest && event.target.closest(SWAP);
    if (!link) return;
    var url = targetUrl(link);
    if (url) prefetch(url).then(function (html) { warmImages(url, html); }).catch(function () {});
  }
  document.addEventListener('touchstart', warm, { passive: true });
  document.addEventListener('pointerdown', warm);
  document.addEventListener('mouseover', warm);

  document.addEventListener('click', async function (event) {
    var link = event.target.closest && event.target.closest(SWAP);
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    var url = targetUrl(link);
    if (!url) return;
    event.preventDefault();
    var ok = await swapTo(url, true);
    if (!ok) location.href = url;
  });

  window.addEventListener('popstate', async function (e) {
    if (!(e.state && e.state.caiConnectedProduct) && !document.querySelector(SWAP)) return;
    var ok = await swapTo(location.href, false);
    if (!ok) location.reload();
  });
})();
